// extracted by mini-css-extract-plugin
module.exports = {"PageHeading":"PageHeading_PageHeading__3MWQe"};